import React, { useState } from "react";
import '../styles/ContactPage.css';
import emailjs from "@emailjs/browser";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    phone: ""
  });

  const [status, setStatus] = useState({ message: "", type: "", show: false });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    emailjs
      .send(
        "service_4k5pywr", // EmailJS Service ID
        "template_51fwpog", // EmailJS Template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject || "Contact Form Submission",
          message: formData.message,
          phone: formData.phone || "Not provided",
          to_email: "info@adamholdingunion.com"
        },
        "8GPDHxNAr7zPrhrRO" // EmailJS Public Key
      )
      .then(() => {
        setStatus({
          message: "Your message has been successfully sent! We'll get back to you soon.",
          type: "success",
          show: true
        });
        setFormData({ name: "", email: "", subject: "", message: "", phone: "" });
        
        // Hide success message after 5 seconds
        setTimeout(() => {
          setStatus({ ...status, show: false });
        }, 5000);
      })
      .catch((error) => {
        console.error("Email sending error:", error);
        setStatus({
          message: "There has been an error sending your message. Please try again.",
          type: "error",
          show: true
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const contactInfo = [
    {
      icon: "📞",
      title: "Phone",
      details: ["+90 538 077 26 31", "+90 531 354 26 31"],
      link: "tel:+905380772631"
    },
    {
      icon: "📧",
      title: "Email",
      details: ["info@adamholdingunion.com", "president@adamholdingunion.com"],
      link: "mailto:info@adamholdingunion.com"
    },
    {
      icon: "📍",
      title: "Headquarters",
      details: ["Istanbul, Turkey", "Muscat, Oman", "Khubar, saudi arabia", "Yaoundé, Cameron"],
      link: "https://maps.google.com/?q=Istanbul+Turkey"
    },
    {
      icon: "⏰",
      title: "Business Hours",
      details: ["Monday - Friday: 9:00 - 18:00", "Saturday: 10:00 - 16:00"],
      link: null
    }
  ];

  const departments = [
    {
      name: "General Inquiries",
      email: "president@adamholdingunion.com",
      phone: "+90 538 077 26 31"
    },
    {
      name: "Business Development",
      email: "info@adamholdingunion.com",
      phone: "+90 538 077 26 31"
    },
    {
      name: "Technical Support",
      email: "v.president@adamholdingunion.com",
      phone: "+90 538 077 26 31"
    },
    {
      name: "Customer Relations",
      email: "info@adamholdingunion.com",
      phone: "+90 538 077 26 31"
    }
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <header className="contact-hero">
        <div className="contact-hero-content">
          <h1 className="contact-hero-title">Contact Us</h1>
          <p className="contact-hero-subtitle">
            Get in touch with our team. We're here to help with your questions and partnership opportunities.
          </p>
        </div>
      </header>

      {/* Contact Info Cards */}
      <section className="contact-info-section">
        <div className="contact-info-grid">
          {contactInfo.map((info, index) => (
            <div key={index} className="contact-info-card">
              <div className="contact-info-icon">{info.icon}</div>
              <h3 className="contact-info-title">{info.title}</h3>
              <div className="contact-info-details">
                {info.details.map((detail, idx) => (
                  <p key={idx}>{detail}</p>
                ))}
              </div>
              {info.link && (
                <a 
                  href={info.link} 
                  className="contact-info-link"
                  target={info.link.startsWith('http') ? "_blank" : "_self"}
                  rel={info.link.startsWith('http') ? "noopener noreferrer" : ""}
                >
                  Contact via {info.title}
                </a>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Contact Form & Departments */}
      <section className="contact-form-section">
        <div className="contact-form-container">
          {/* Contact Form */}
          <div className="contact-form-wrapper">
            <h2 className="contact-form-title">Send Us a Message</h2>
            <p className="contact-form-subtitle">
              Fill out the form below and our team will respond as soon as possible.
            </p>
            
            {status.show && (
              <div className={`contact-status contact-status--${status.type}`}>
                <span className="contact-status-icon">
                  {status.type === 'success' ? '✓' : '✗'}
                </span>
                <p>{status.message}</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Full Name *"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email Address *"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message *"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="form-textarea"
                  rows="6"
                />
              </div>

              <button 
                type="submit" 
                className="contact-form-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="contact-form-spinner"></span>
                    Sending...
                  </>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>
          </div>

          {/* Departments Info */}
          <div className="contact-departments-wrapper">
            <h2 className="contact-departments-title">Contact by Department</h2>
            <p className="contact-departments-subtitle">
              Reach out to specific departments for specialized inquiries.
            </p>
            
            <div className="contact-departments-grid">
              {departments.map((dept, index) => (
                <div key={index} className="contact-department-card">
                  <h3 className="contact-department-name">{dept.name}</h3>
                  <div className="contact-department-info">
                    <a href={`mailto:${dept.email}`} className="contact-department-link">
                      📧 {dept.email}
                    </a>
                    <a href={`tel:${dept.phone}`} className="contact-department-link">
                      📞 {dept.phone}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="contact-map-section">
        <h2 className="contact-map-title">Our Headquarters</h2>
        <p className="contact-map-subtitle">
          Visit us at our main office in Istanbul, Turkey.
        </p>
        <div className="contact-map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3007.486897759364!2d28.803523175862296!3d41.08020717134044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caaf8cdd315363%3A0x2a861f427afc8819!2sBeyaz%20Tower%20Plaza!5e0!3m2!1str!2str!4v1771515462111!5m2!1str!2str"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Adam Holding Union Headquarters Location"
          ></iframe>
          <div className="contact-map-overlay">
            <div className="contact-map-info">
              <h3>Adam Holding Union HQ</h3>
              <p>📍 Istanbul, Turkey</p>
              <p>⏰ Mon-Fri: 9:00-18:00</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="contact-cta">
        <div className="contact-cta-content">
          <h2 className="contact-cta-title">Ready to Start a Partnership?</h2>
          <p className="contact-cta-text">
            Let's discuss how we can work together to achieve your business goals.
          </p>
          <div className="contact-cta-buttons">
            <a href="tel:+905380772631" className="contact-cta-button contact-cta-button--primary">
              Call Now
            </a>
            <a href="mailto:info@adamholdingunion.com" className="contact-cta-button contact-cta-button--secondary">
              Email Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;